export default __webpack_public_path__ + "static/media/github-logo.bd46688f.svg";